'use strict';

export default {
  isFetching: null,
};



// WEBPACK FOOTER //
// ./app/src/services/conversations_fetching.js